/* eslint-disable import/prefer-default-export */

export const checkForDuplicateIDs = () => {
  if (window.Shopify.theme.role !== "development") {
    return;
  }

  // check DOM for duplicate IDs
  const idMap = new Map();

  // Build map of IDs
  document.querySelectorAll("[id]:not([id='']").forEach((el) => {
    const elements = idMap.get(el.id) || [];
    elements.push(el);
    idMap.set(el.id, elements);
  });

  // Check for duplicates
  Array.from(idMap.entries()).forEach(([id, elements]) => {
    if (elements.length > 1) {
      // eslint-disable-next-line no-console
      console.error(`Duplicate IDs found for #${id}`, elements);
    }
  });
};

(() => {
  checkForDuplicateIDs();
})();
